import type { StepperItem } from '@nuxt/ui';
import type { BaselineVariableType } from '../types';

export const useBaselineConstants = () => {
  const { t } = useI18n();

  const stepperItems = computed<StepperItem[]>(() => [
    {
      title: t('baseline.energy_use_short'),
      routeName: 'baseline-create-energy-use',
    },
    {
      title: t('baseline.model_selection_short'),
      routeName: 'baseline-create-model-selection',
    },
    {
      title: t('baseline.training_period_short'),
      routeName: 'baseline-edit-training-period',
    },
    {
      title: t('baseline.review'),
      routeName: 'baseline-edit-review',
    },
    {
      title: t('baseline.validation'),
      routeName: 'baseline-edit-validation',
    },
  ]);

  const variablesItems = ref<{ value: BaselineVariableType; label: string; description: string }[]>([
    {
      value: 'degree_days',
      label: t('baseline.variables_outside_temperature'),
      description: t('baseline.variables_outside_temperature_description'),
    },
    {
      value: 'production',
      label: t('baseline.variables_production'),
      description: t('baseline.variables_production_description'),
    },
  ]);

  return {
    stepperItems,
    variablesItems,
  };
};
